import CountUp from "react-countup";
import React from "react";

export default function Feedback({ feedbacks }) {
  return (
    <div className="flex flex-col items-center py-16 px-4 md:px-0">
      <div className="relative mb-8 text-center">
        <h1
          className="text-3xl md:text-4xl font-bold"
          data-aos="fade-left"
          data-aos-anchor="#example-anchor"
          data-aos-offset="500"
          data-aos-duration="500"
        >
          Clients Feedback
        </h1>
        <div className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 bg-green-500 text-white text-sm px-2 py-1 rounded-full">
          <CountUp start={0} end={500} duration={8} delay={0.1} />+ Trusted Clients
        </div>
      </div>

      <div className="flex flex-col lg:flex-row md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-4">
        {feedbacks.map((feedback) => (
          <div
            key={feedback.id}
            className="bg-white p-6 rounded-lg shadow-lg w-full max-w-xs md:w-80"
            data-aos="zoom-out-down"
          >
            <div className="text-gray-400 text-4xl mb-4"> “</div>
 <p className="text-gray-700 mb-4">{feedback.text}</p>
            <div className="flex items-center">
              <img
                src={feedback.image}
                alt={feedback.alt}
                className="w-10 h-10 rounded-full mr-4"
              />
              <div>
                <p className="font-bold">{feedback.name}</p>
                <p className="text-gray-500">{feedback.position}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}